import { Component, OnInit, Input,ChangeDetectionStrategy, ChangeDetectorRef, TemplateRef, Inject, LOCALE_ID } from '@angular/core';
import { TreeService, TreeGroup } from '@schoolbelle/api/group-to-group';
import { LetterTargetService } from '@schoolbelle/api/letter-target'
import { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { escapeRegExp } from '@schoolbelle/common/functions';

@Component({
  selector: 'group-tab',
  templateUrl: './group-tab.component.html',
  styleUrls: ['./group-tab.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class GroupTabComponent implements OnInit {
  @Input('group') group:TreeGroup;
  @Input('mode') mode:'select'|'compose'|'view';
  @Input() tabTemplate:TemplateRef<any>;


  checked:0|1|2 = 0; 
  isTogglable:boolean = false;
  constructor(
    public treeService:TreeService,
    public targetService:LetterTargetService,
    public cdRef:ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId:string,
  ) { }

  subscription = new Subscription();
  ngOnInit() {
    this.isTogglable = this.getTogglableStatus();

    this.subscription.add(
      this.group.onOpen.pipe(startWith(this.group.opened))
      .subscribe((group_id)=>{
        this.cdRef.detectChanges()
      })
    );
    this.subscription.add(
      this.targetService.onChange.pipe(startWith(this.targetService.targets))
      .subscribe(()=>{
        this.updateCheckedStatus();
        this.cdRef.detectChanges()
      })
    );
  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
  }  
  private getTogglableStatus () {
    if (this.group.depth < 2 && (!Array.isArray(this.group.subgroups) || this.group.subgroups.length ===0)) return false;
    return true;
  }
  get short_group_name () {
    let group_name = this.group.group_name;
    // if (this.group.parentgroup) group_name = group_name.replace(this.group.parentgroup.group_name , '').trim();

    if (this.group.parentgroup && !this.localeId.includes('vi')) {
      group_name = group_name.replace(escapeRegExp(this.group.parentgroup.group_name) + ' ', '').trim() || group_name;
    }

    return group_name;
  }
  open () {
    const treeGroup = this.treeService.root.find({group_id:this.group.group_id});
    if (treeGroup) {
      const targetgroups = this.targetService.targets.map(target=>treeGroup.find({group_id:target.group_id}));
      const firstDepth2target = targetgroups.find(group=>group && group.depth === 2);
      if (firstDepth2target) firstDepth2target.open();
      else treeGroup.open();
    }
  }
  private updateCheckedStatus () {
    this.checked = this.targetService.isChecked(this.group.group_id, 'all') || this.targetService.isChecked(this.group.group_id, 'studentparent_all');
  }
  stopPropagation ($event:MouseEvent) {
    $event.stopPropagation();
  }
  toggle (group:TreeGroup = this.group) {
    if (this.isTogglable === false) return;
    if (this.checked !== 2) {
      this.targetService.setScopes(group.group_id, 'studentparent_all', 'both');
    }  
    else {
      this.targetService.setScopes(group.group_id, '', 'both');
    }  
  }
  

}
